import { Injectable } from "@angular/core";
import { ClientesServiceBackend } from "@serviceBackends";
import { ClienteDTO, ClientePedidoPermisoTemplateDTO, ClientePermisoTemplateDTO } from "@DTOS";
import { Nilable } from "@shared/utils";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ClientesService {
    constructor(protected clientesServiceBackend: ClientesServiceBackend) {}

    public async obtenerClientes(): Promise<ClienteDTO[]> {
        return await this.clientesServiceBackend.getClientes();
    }

    public async getCliente(id: number): Promise<ClienteDTO> {
        return await this.clientesServiceBackend.getCliente(id);
    }

    public async agregarCliente(cliente: ClienteDTO): Promise<Nilable<ClienteDTO>> {
        return await this.clientesServiceBackend.postCliente(cliente);
    }

    public async guardarCliente(clienteDTO: ClienteDTO): Promise<Nilable<ClienteDTO>> {
        return await this.clientesServiceBackend.patchCliente(clienteDTO);
    }

    public async borrarCliente(clienteDTO: ClienteDTO): Promise<boolean> {
        return await this.clientesServiceBackend.deleteCliente(clienteDTO);
    }

    public obtenerTemplates(clienteDTO: ClienteDTO): Observable<ClientePermisoTemplateDTO[]> {
        return this.clientesServiceBackend.getClienteTemplates(clienteDTO.id);
    }

    public agregarTemplate(clienteDTO: ClienteDTO, pedidoTemplate: ClientePedidoPermisoTemplateDTO): Observable<void> {
        return this.clientesServiceBackend.postClienteTemplate(clienteDTO.id, pedidoTemplate);
    }

    public borrarTemplate(clienteDTO: ClienteDTO, templatePermiso: ClientePermisoTemplateDTO): Observable<void> {
        return this.clientesServiceBackend.deleteClienteTemplate(clienteDTO.id, templatePermiso.id);
    }
}
